import { PurchaseOrderLine } from 'tms-lib';

export interface PurchaseContractLineDetails {
  id: string;
  contractNo: number;
  supplierKey: string;
  supplierName: string;
  currency: string;
  description: string;
  productId: string;
  productKey: string;
  productDescription: string;
  supplierReference: string;
  unitOfMeasure: string;
  unitOfMeasureId: string;
  quantity: number;
  price: number;
  contractValue: number;
  contractBalance: number;
  contractBalanceValue: number;
  availableDate: Date;

  purchaseOrderLines: PurchaseOrderLine[];
}
